import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Input = styled.input<{
  placeholderTextColor?: React.CSSProperties['color'];
}>`
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  ::placeholder {
    ${({ placeholderTextColor }) =>
      placeholderTextColor ? { color: placeholderTextColor } : {}};
  }
`;

export const Label = styled.label`
  font-weight: bold;
`;
